export function caseInsensitiveStringEqual(a: string, b: string) {
  return a.toLowerCase() === b.toLowerCase();
}
